import { render, staticRenderFns } from "./CartTab.vue?vue&type=template&id=5f59f911&scoped=true&"
import script from "./CartTab.vue?vue&type=script&lang=js&"
export * from "./CartTab.vue?vue&type=script&lang=js&"
import style0 from "./CartTab.vue?vue&type=style&index=0&id=5f59f911&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f59f911",
  null
  
)

export default component.exports